namespace Nobox {
    @Serenity.Decorators.registerFormatter()
    export class TimezoneFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            return moment.utc(ctx.value).tz($.cookie("timezone")).format($.cookie("formatdate") + ", " + $.cookie("formattime"))
        }
    }
}